import * as React from 'react';

import Head from './Head';
import Nav from '../../containers/Nav/Nav';
import Footer from '../../containers/Footer/Footer';

import styles from './Layout.scss';

const Layout: React.SFC = ({ children }) => (
  <div className={styles.layout}>
    <Head />
    <Nav />
    <div className={styles.content}>{children}</div>
    <Footer />
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// /www/client/src/components/Layout/Layout.tsx